import * as uuid from 'uuid'
import store from '../redux/store'
import { notificationsActions } from '../redux/actions/notifications'

/**
 * Programmatic API for the notification center.
 *
 * This is the entry point for injecting notifications from anywhere in the code
 * base — including non-React modules — by dispatching to the redux store. In the
 * future the same store can be fed by server responses without touching callers.
 *
 * @example
 *   notificationService.push({ payload: { title: 'Custom', body: 'Anything' } })
 */

/**
 * Pushes a notification onto the stack (newest first).
 * @param {Object} [notification] see {@link notificationsActions.push}
 * @returns {string} the notification id (generated when not supplied)
 */
const push = (notification = {}) => {
  const id = notification.id ?? uuid.v4()
  store.dispatch(notificationsActions.push({ ...notification, id }))
  return id
}

const dismiss = (id) => store.dispatch(notificationsActions.dismiss(id))
const dismissAll = () => store.dispatch(notificationsActions.dismissAll())
const markRead = (id) => store.dispatch(notificationsActions.markRead(id))
const markAllRead = () => store.dispatch(notificationsActions.markAllRead())
const open = () => store.dispatch(notificationsActions.open())
const close = () => store.dispatch(notificationsActions.close())
const toggle = () => store.dispatch(notificationsActions.toggle())

const notificationService = {
  push,
  dismiss,
  dismissAll,
  markRead,
  markAllRead,
  open,
  close,
  toggle,
}

export default notificationService
